var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUExp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 40,
    viewBox: "0 0 93 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_59_3041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 18C4 9.16344 11.1634 2 20 2H73C81.8366 2 89 9.16344 89 18C89 26.8366 81.8366 34 73 34H20C11.1634 34 4 26.8366 4 18Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.793 12.523H41.332V13.407H34.793V12.523ZM34.624 20.115L34.494 19.192C36.613 19.192 39.46 19.166 41.878 18.867L41.943 19.673C39.486 20.076 36.691 20.115 34.624 20.115ZM36.054 13.186H37.107V19.439H36.054V13.186ZM39.018 13.186H40.071V19.439H39.018V13.186ZM42.593 11.262H43.685V23.014H42.593V11.262ZM43.425 15.955H45.609V16.865H43.425V15.955ZM54.15 11.262H55.229V17.385H54.15V11.262ZM47.637 17.996H55.242V20.791H48.716V22.442H47.663V19.985H54.176V18.854H47.637V17.996ZM47.663 22.039H55.632V22.884H47.663V22.039ZM46.22 11.73H47.273V13.433H50.653V11.73H51.719V16.878H46.22V11.73ZM47.273 14.265V16.007H50.653V14.265H47.273ZM65.122 11.249H66.201V23.027H65.122V11.249ZM57.244 19.296H58.219C60.182 19.296 61.937 19.218 64.017 18.88L64.134 19.764C62.002 20.115 60.234 20.193 58.219 20.193H57.244V19.296ZM57.218 12.354H62.652V16.553H58.323V19.634H57.244V15.669H61.56V13.238H57.218V12.354ZM67.514 17.502H78.135V18.386H67.514V17.502ZM72.298 15.786H73.364V17.957H72.298V15.786ZM68.892 21.87H76.965V22.754H68.892V21.87ZM68.892 19.361H69.971V22.156H68.892V19.361ZM72.831 11.6C75.34 11.6 76.965 12.497 76.965 13.953C76.965 15.422 75.34 16.293 72.831 16.293C70.309 16.293 68.697 15.422 68.697 13.953C68.697 12.497 70.309 11.6 72.831 11.6ZM72.831 12.484C70.985 12.484 69.802 13.043 69.802 13.953C69.802 14.876 70.985 15.422 72.831 15.422C74.677 15.422 75.86 14.876 75.86 13.953C75.86 13.043 74.677 12.484 72.831 12.484Z",
    fill: "#282D4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8334 23.8333L14.8334 17.5H17.5V13.5L26.5 13.5V17.5H29.1667V23.8333H23.5V22C23.5 21.1716 22.8285 20.5 22 20.5C21.1716 20.5 20.5 21.1716 20.5 22V23.8333H14.8334ZM15.8334 22.8333H19.5V22C19.5 20.6193 20.6193 19.5 22 19.5C23.3808 19.5 24.5 20.6193 24.5 22V22.8333H28.1667V18.5H25.5L25.5 14.5L18.5 14.5V18.5H15.8334V22.8333Z",
    fill: "#282D4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1667 16L29.1667 17.5L28.1667 17.5V16H29.1667Z",
    fill: "#282D4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8334 16L15.8334 17.5H14.8334L14.8334 16H15.8334Z",
    fill: "#282D4B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1667 16V18H20.1667V16H21.1667Z",
    fill: "#282D4B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1667 12V13.5H20.1667V12L21.1667 12Z",
    fill: "#282D4B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8334 16V18H22.8334V16H23.8334Z",
    fill: "#282D4B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8334 12V13.5H22.8334V12L23.8334 12Z",
    fill: "#282D4B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5 12V13.5L25.5 13.5V12L26.5 12Z",
    fill: "#282D4B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 12V13.5L17.5 13.5L17.5 12L18.5 12Z",
    fill: "#282D4B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_59_3041",
    x: 0,
    y: 0,
    width: 93,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_59_3041"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_59_3041",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUExp);
export default __webpack_public_path__ + "static/media/u_exp.d52cc05d459a21a769daef4350d51ad0.svg";
export { ForwardRef as ReactComponent };